import { useCallback } from 'react';

import { diagnostics } from '@/utils/diagnostics';

import { FamilyTreeEffectFn, MarriageLayoutEffect } from '../types';
import { computeFamilyTreeLayoutSimple } from '../utils/elkLayoutSimple';

/**
 * Effect to compute marriage-based family tree layout.
 * This effect is triggered when needsMarriageLayoutComputation is true.
 */
export function useMarriageLayoutEffect(): FamilyTreeEffectFn<MarriageLayoutEffect> {
  return useCallback<FamilyTreeEffectFn<MarriageLayoutEffect>>(
    (state, effect, dispatch) => {
      if (!state.familyTreeData) {
        return;
      }

      // Compute marriage-based layout asynchronously
      // Ignore custom positions only for this calculation so failure keeps the current layout.
      computeFamilyTreeLayoutSimple(
        effect.isAutoPosition ? { ...state, nodePositions: [] } : state
      )
        .then((layoutResult) => {
          // Dispatch action to update the state with the new layout
          dispatch({
            type: 'MARRIAGE_LAYOUT_COMPUTED',
            layoutNodes: layoutResult.nodes,
            layoutEdges: layoutResult.edges,
            isAutoPosition: effect.isAutoPosition,
          });
        })
        .catch((error: Error) => {
          diagnostics.error('Marriage layout computation failed', error);
          dispatch({
            type: 'MARRIAGE_LAYOUT_FAILED',
            error: error.message,
          });
        });
    },
    []
  );
}
